import { render, staticRenderFns } from "./ExternalPagination.vue?vue&type=template&id=5a2eba34&"
import script from "./ExternalPagination.vue?vue&type=script&lang=js&"
export * from "./ExternalPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports